module.exports = __webpack_public_path__ + "static/media/teapot_03.b04f7c13.png";